/* unplugin-vue-components disabled */import { render } from "./filters.vue?vue&type=template&id=40894999&scoped=true"
import script from "./filters.vue?vue&type=script&lang=js"
export * from "./filters.vue?vue&type=script&lang=js"

import "./filters.vue?vue&type=style&index=0&id=40894999&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40894999"],['__file',"src/components/filters/filters-elements/filters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40894999"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40894999', __exports__)) {
    api.reload('40894999', __exports__)
  }
  
  module.hot.accept("./filters.vue?vue&type=template&id=40894999&scoped=true", () => {
    api.rerender('40894999', render)
  })

}


export default __exports__